import type { Step } from 'react-joyride';

export const policyArchiveTourSteps: Step[] = [
    {
        target: 'body',
        content:
            'ໜ້ານະໂຍບາຍເກັບໄວ້: ເບິ່ງນະໂຍບາຍທີ່ບໍ່ໄດ້ໃຊ້ງານແລ້ວ ແລະ ຄົ້ນຫາຂໍ້ມູນຍ້ອນຫຼັງ.',
        placement: 'center',
        disableBeacon: true,
    },
    {
        target: '[data-tourid="policy-archive-toolbar"]',
        content: 'ສ່ວນຫົວໜ້າຂອງໜ້າ ແລະ ປຸ່ມເລີ່ມທົດສອບ.',
        placement: 'bottom',
    },
    {
        target: '[data-tourid="policy-archive-filter"]',
        content: 'ຟິວເຕີກັ່ນຕອງຂໍ້ມູນນະໂຍບາຍເກັບໄວ້.',
        placement: 'bottom',
    },
    {
        target: '[data-tourid="policy-archive-table"]',
        content: 'ຕາຕະລາງສະແດງລາຍການນະໂຍບາຍເກັບໄວ້.',
        placement: 'top',
    },
];
